// @flow
import React from 'react';
import { Route, Switch } from 'react-router';
import PrivateRoute from 'components/common/router/PrivateRoute';

import StatusTrackerPage from 'components/pages/StatusTrackerPage';
import StatusTrackerError from 'components/pages/StatusTrackerError';

const NoRoute = () => <div> Invalid route </div>;

// eslint-disable-next-line react/no-multi-comp
const Router = () => {
  return (
    <Switch key="routes">
      <Route exact path="/" component={StatusTrackerPage} />
      <PrivateRoute path="/statusTrackerError" component={StatusTrackerError} />
      <Route component={NoRoute} />
    </Switch>
  );
};

export default Router;



// WEBPACK FOOTER //
// ./src/components/statusTracker/AppRouter.js